import React from "react";

function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <g clip-path="url(#clip0_2012_28128)">
        <path
          d="M9 18.25C11.3869 18.25 13.6761 17.3018 15.364 15.614C17.0518 13.9261 18 11.6369 18 9.25C18 6.86305 17.0518 4.57387 15.364 2.88604C13.6761 1.19821 11.3869 0.25 9 0.25C6.61305 0.25 4.32387 1.19821 2.63604 2.88604C0.948212 4.57387 0 6.86305 0 9.25C0 11.6369 0.948212 13.9261 2.63604 15.614C4.32387 17.3018 6.61305 18.25 9 18.25ZM7.59375 12.0625H8.4375V9.8125H7.59375C7.12617 9.8125 6.75 9.43633 6.75 8.96875C6.75 8.50117 7.12617 8.125 7.59375 8.125H9.28125C9.74883 8.125 10.125 8.50117 10.125 8.96875V12.0625H10.4062C10.8738 12.0625 11.25 12.4387 11.25 12.9062C11.25 13.3738 10.8738 13.75 10.4062 13.75H7.59375C7.12617 13.75 6.75 13.3738 6.75 12.9062C6.75 12.4387 7.12617 12.0625 7.59375 12.0625ZM9 4.75C9.29837 4.75 9.58452 4.86853 9.7955 5.0795C10.0065 5.29048 10.125 5.57663 10.125 5.875C10.125 6.17337 10.0065 6.45952 9.7955 6.6705C9.58452 6.88147 9.29837 7 9 7C8.70163 7 8.41548 6.88147 8.2045 6.6705C7.99353 6.45952 7.875 6.17337 7.875 5.875C7.875 5.57663 7.99353 5.29048 8.2045 5.0795C8.41548 4.86853 8.70163 4.75 9 4.75Z"
          fill="#0055A4"
        />
      </g>
      <defs>
        <clipPath id="clip0_2012_28128">
          <path d="M0 0.25H18V18.25H0V0.25Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default InfoIcon;
